<template>
  <div class="p-input-icon-right w-100">
    <Calendar
      :class="className"
      :clearable="clearable"
      :date-format="dateFormat"
      class="w-100"
      :disabled-dates="disabledDates"
      :disabled-days="disabledDays"
      :hour-format="hourFormat"
      :icon="icon"
      :input-class="inputClass"
      :manual-input="manualInput"
      :max-date="maxDate"
      :min-date="minDate"
      :number-of-months="numberOfMonths"
      :placeholder="placeholder"
      selection-mode="range"
      show-icon
      :show-time="showTime"
      :show-week="showWeek"
      :value="value"
      @input="onInput"
    />
    <i v-if="canClear" class="fas fa-xmark" @click="clear" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, null],
      required: true,
    },
    dateFormat: {
      type: String,
      default: () => 'dd/M/yy',
    },
    numberOfMonths: {
      type: Number,
      default: 2,
    },
    icon: {
      type: String,
      default: () => 'fas fa-calendar-week color-primary-2',
    },
    manualInput: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    disabledDates: {
      type: Array,
      description: 'Array with dates to disable.',
      default: () => [],
    },
    disabledDays: {
      type: Array,
      description: 'Array with disabled weekday numbers.',
      default: () => [],
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    hourFormat: {
      type: String,
      default: '12',
    },
    showWeek: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onInput(v) {
      this.$emit('input', v);
    },
    clear() {
      this.value = [];
      this.$emit('input', []);
    },
  },
  computed: {
    canClear() {
      return this.value !== null && this.value.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.p-datepicker table) {
  font-family: Lato, sans-serif;
  font-size: 13px;
}

:deep(.p-datepicker-header) {
  background: white !important;
  border-bottom: unset !important;
  .p-datepicker-month,
  .p-datepicker-year {
    padding: 0 !important;
  }

  .p-datepicker-prev,
  .p-datepicker-next {
    background: #f8f8f8 !important;
  }
}

:deep(.p-datepicker-calendar-container) {
  padding: 0 5px 0 5px;
  span {
    font-weight: 600;
  }
  td {
    padding: 0.05rem;
  }
}

:deep(thead) {
  background: #f8f8f8 !important;
}

:deep(.p-datepicker-today) {
  span {
    background: unset !important;
  }
}

:deep(span.p-highlight) {
  background: #ff7058 !important;
}

:deep(td.p-datepicker-other-month) {
  visibility: hidden;
}

:deep(.p-inputtext) {
  font-family: Lato, sans-serif;
  color: #495057;
  width: 100%;
  border: 1px solid rgba(60, 60, 60, 0.26);
  order: 2 !important;
  border-radius: 0 4px 4px 0;
  padding: 0.375rem 1.8rem 0.375rem 0.75rem;
}

:deep(.p-inputtext:enabled:focus) {
  box-shadow: 0 0 0 0.2rem rgba(45, 183, 130, 0.25);
  border: 1px solid rgba(60, 60, 60, 0.26);
}

:deep(p-datepicker-trigger) {
  order: 1 !important;
  border-radius: 4px 0 0 4px !important;
}

:deep(.p-button) {
  background: white;
  border-radius: 4px 0 0 4px !important;
  border: 1px solid rgba(60, 60, 60, 0.26);
  pointer-events: none;
  padding: 0.375rem 0;
}

:deep(.p-button.p-button-icon-only) {
  padding: 0.375rem 0;
}

i {
  color: #9d9d9d !important;
  font-size: 15px;
}

i:active {
  transform: scale(95%);
}
</style>
